import React from "react";
import Form from "react-bootstrap/Form";
import { Navigate, useLocation } from "react-router-dom";
import DownloadResponsePdf from "../ReportGeneration/DownloadResponsePdf";
import BackButton from "../../utils/BackButton";

export default function Response() {
  const location = useLocation();
  const survey = location.state?.survey;

  if (!survey) {
    return <Navigate to="/admin/patient/response-survey-list" replace />;
  }

  const {
    userAnswers,
    surveyDetails,
    respondentId,
    surveyId,
    respondentDetails,
  } = survey;


  return (
    <div className="Dashboard-wrapper">
      <div className="dashboard-insights">
        <Form>
          <div className="p-4  rounded ">
            <div className="d-flex align-items-center justify-content-between mb-4">
              <div className="d-flex gap-3 align-items-center ">
                <BackButton />

                <h2 className="text-center text-capitalize flex-grow-1">
                  {surveyDetails.title}
                </h2>
              </div>
              <DownloadResponsePdf
                patientId={respondentId}
                surveyId={surveyId}
                respondentDetails={respondentDetails}
              />
            </div>

            {userAnswers.map((item, index) => (
              <div key={index} className="mb-4 p-3 border rounded bg-white">
                <p className="fw-bold">
                  Q{index + 1}: {item.question.text}
                </p>

                {/* Render Single Choice */}
                {(item.question.type === "Single Choice" ||
                  item.question.type === "single-choice") && (
                  <div className="ps-3">
                    {item.question.options.map((option, idx) => (
                      <label key={idx} className="d-block">
                        <input
                          type="radio"
                          name={item._id}
                          value={option}
                          checked={item.answer.includes(option)}
                          disabled
                          className="me-2 patient-resp-box"
                        />
                        {option}
                      </label>
                    ))}
                  </div>
                )}

                {/* Render Multiple Choice */}
                {(item.question.type === "Multiple Choice" ||
                  item.question.type === "multiple-choice") && (
                  <div className="ps-3">
                    {item.question.options.map((option, idx) => (
                      <label key={idx} className="d-block">
                        <input
                          type="checkbox"
                          value={option}
                          checked={item.answer.includes(option)}
                          disabled
                          className="me-2"
                        />
                        {option}
                      </label>
                    ))}
                  </div>
                )}

                {/* Render Short and Long Answers */}
                {(item.question.type === "Short Answer" ||
                  item.question.type === "short-answer" ||
                  item.question.type === "Long Answer" ||
                  item.question.type === "long-answer") && (
                  <p className="text-secondary mt-2 ps-3">{item.answer[0]}</p>
                )}

                {/* Render Star Rating */}
                {(item.question.type === "Star Rating" ||
                  item.question.type === "star-rating") && (
                  <div className="ps-3">
                    {[...Array(5)].map((_, idx) => (
                      <span
                        key={idx}
                        className={`fs-4 ${
                          idx < parseInt(item.answer[0])
                            ? "text-warning"
                            : "text-muted"
                        }`}
                      >
                        ★
                      </span>
                    ))}
                  </div>
                )}

                {/* Render Slider */}
                {(item.question.type === "Slider" ||
                  item.question.type === "slider") && (
                  <input
                    type="range"
                    min="0"
                    max="10"
                    value={item.answer[0]}
                    disabled
                    className="form-range mt-2 ps-3"
                    style={{ width: "200px" }}
                  />
                )}

                {/* Render Yes/No Question */}
                {(item.question.type === "Yes/No Question" ||
                  item.question.type === "yes/no-question") && (
                  <div className="ps-3">
                    <label className="d-block">
                      <input
                        type="radio"
                        name={item._id}
                        value="Yes"
                        checked={item.answer[0] === "Yes"}
                        disabled
                        className="me-2 patient-resp-box"
                      />
                      Yes
                    </label>
                    <label className="d-block">
                      <input
                        type="radio"
                        name={item._id}
                        value="No"
                        checked={item.answer[0] === "No"}
                        disabled
                        className="me-2 patient-resp-box"
                      />
                      No
                    </label>
                  </div>
                )}
              </div>
            ))}
          </div>
        </Form>
      </div>
    </div>
  );
}
